<template>
    <div id="register_page">      
      <input-data v-bind:info_page="info_page" @updateData="info_page = $event"></input-data>
      <preview v-bind:info_page="info_page" @updateStatusPage="info_page = $event"></preview>
    </div>
</template>
<script>
import InputData from "./components/RegisterPage/InputData.vue";
import Preview from "./components/RegisterPage/Preview.vue";
import HeaderSection from "./components/Common/HeaderSection.vue";
export default {
  name: "components",
  components: {
    InputData,
    Preview,
    HeaderSection
  },  
  data: function(){

    return {
      api_data: null,
      info_page:{
        errors: {
        },
        status_page: 'input',
        user_info:{
          name: '',
          email: '',
          date_of_birth: '',
          address: '',
          phone: '',
          counselor_title: '',
          avatar_file: '',
          avatar: '',
          linkedin: '',
          level_education: '',
          available_service: [],
          introduce: '',
          degree: [],
          experience: [],
          introduce: '',
          score: {
            'ielts': '',
            'toefl': '',
            'toeic': '',
            'sat': '',
            'act': '',
            'gmat': '',
            'gre': ''
          }
        }
      }      
    }
  },
  created: function(){    
    // this.$http
    //   .get('http://localhost:3000/api/v1/users')
    //   .then((response) =>{
    //     // console.log(response.data);
    //     this.api_data = response.data;
    //     // console.log(this.api_data);
    //   });

    // console.log(this.api_data);
  },
  // created: function(){
  //   console.log(this.info_page.user_info.name)
  // },
  mounted: function(){    
    // console.log(this.info_page.user_info.name)
  },
  methods: {
    set_status: function(status){
      this.info_page['status_page'] = status
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/RegisterPage.vue